export function triggerHapticFeedback() {
  if ('vibrate' in navigator) {
    // Gentle vibration for 10ms
    navigator.vibrate(10);
  }
}